import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';

@inject('ticketStore')
@observer
export default class TicketItem extends Component {

  toggleChange = () => {
    const {
      ticketStore: {
        toggleChecked,
      },
      item: {
        pin,
      }
    } = this.props;

    toggleChecked(pin);
  }

  //주문 상태는 사용가능 혹은 다른 이유로 티켓을 사용할 수 없을 경우 나오는 메세지 출력
  renderTicketStatusMessage = (ticketMessage) => {
    return (
      <div className="desc-state desc-disabled" dangerouslySetInnerHTML={ {__html: ticketMessage} } />
    )
  }

  renderOrderStateName = (orderState, orderStateNm, ticketUsable, ticketMessage) => {
  
    // //사용완료
    if (orderState === 'A') {
      return (
        <span className="txt-state txt-used">{orderStateNm}</span>
      )
    }

    if (orderState !== 'A' && orderState !== 'E') {
      return (
        <span className="txt-state txt-fail">{orderStateNm}</span>
      )
    }

    //사용가능
    if (orderState === 'E') {
      if(ticketUsable) {
        return (
          <span className="txt-state txt-use">{orderStateNm}</span>
        )          
      }

      return (
        <div className="box-state">
          <span className="txt-state txt-disabled">{orderStateNm}</span>
          {this.renderTicketStatusMessage(ticketMessage)}
        </div>
      )
    }
  }

  render() {
    const {
      item: {
        itemNm,
        pin,
        orderState,
        orderStateNm,
        checked,
        ticketStatus: {
          usable: ticketUsable,
          message: ticketMessage,
        }
      }
    } = this.props;

    return (
      <div className="item-content">
        <label>
          <input 
            type="checkbox"
            onChange={this.toggleChange}
            disabled={orderState !== 'E' || !ticketUsable}
            checked={checked}
          />
          <span className="icon-chk"></span>
          <span className="txt-chk">{itemNm}</span>
          <span className="txt-pincode">핀번호 : {pin}</span> 
          {this.renderOrderStateName(orderState, orderStateNm, ticketUsable, ticketMessage)}
        </label>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/TicketItem.jsx